import TableCellRenderer from '../../../table/TableCellRenderer'
import CorporateScheduleCalculator from '../../../controls/dateControls/CorporateScheduleCalculator'
import DateSelector from '../../../controls/dateControls/DateSelector'
import messageResource from '../../../messageResource'
import _ from 'underscore'

function EffectiveDateCellRenderer()
{}

EffectiveDateCellRenderer.prototype = _.create(TableCellRenderer.prototype);

EffectiveDateCellRenderer.prototype.init = function( invertedDays, weekStartDay, changesCallback, prefix, scrollableContainer, corporateSchedule )
{
    TableCellRenderer.call( this );
    this.invertedDays = invertedDays;
    this.weekStartDay = weekStartDay;
    this.changesCallback = changesCallback;
    this.prefix = prefix;
    this.scrollableContainer = scrollableContainer;
    this.corporateSchedule = corporateSchedule;
    return this;
};


EffectiveDateCellRenderer.prototype.generateContent = function( cell )
{
    cell.getCellEl().innerHTML = 
    "<table class='caption' cellpadding=0 cellspacing=0 border=0><tbody><tr><td>" + 
        this.prefix + 
    "</td><td></td><td>:</td></tr></tbody></table>" +
    "<div class ='current'>" +
        messageResource.getMessage("user.add_edit.js.wd_editor.working_schedule_current") +
    "</div>";

    var scheduleCalculator = new CorporateScheduleCalculator().init(this.invertedDays, this.corporateSchedule );

    var dateSelector = new DateSelector({
        minValue: new Date(1970, 0, 1),
        weekStartDay: this.weekStartDay - 1,
        renderTo: cell.getCellEl().firstChild.firstChild.firstChild.firstChild.nextSibling,
        scheduleCalculator: scheduleCalculator,
        date: cell.getValue(),
        format: Date.convertSmartToExtDateFormat( window.SystemSettings.dateFormat ).replace(/F/, "M"),
        scrollableContainer: this.scrollableContainer
    });

    dateSelector.menu.on('beforeshow', () => cell.getTable().setOpenedExtJSSelector(cell.dateSelector));

    var self = this;
    dateSelector.on("change", function() {
        cell.setValue( this.getValue() );
        cell.updateUI();
        self.changesCallback();
    });
    cell.dateSelector = dateSelector;
};

EffectiveDateCellRenderer.prototype.getCellClassName = function( cell )
{
    var classes = ["effectiveDateCell"];
    if( !cell.isValid() )
        classes.push("invalid");
    return classes;
};

EffectiveDateCellRenderer.prototype.updateUI = function( cell )
{
    TableCellRenderer.prototype.updateUI.call( this, cell );
    cell.dateSelector.setDisabled( cell.getRow().isMarkedToRemove() );
};

export default EffectiveDateCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/EffectiveDateCellRenderer.js